import { createContext, useContext, useReducer } from 'react'
import { reducer } from './reducer'
import { useComponentIsMountedRef } from 'Hooks'

CreateMacroDataContext = createContext()

export defaultState = -> {
  name: 'Thing factory'
  steps: [['name']]
  fieldData: {
    name: {
      key: 'name',
      label: 'Name'
      type: 'string',
    }
  }
  isHidden: false
  graph: undefined
  typeNode: 'Thing'
  label: 'Thing'
  confirmationMessage: 'And he said, \'Let there be things!\', and then there were things.'
}

export CreateMacroDataProvider = ({ children, initialState = defaultState() }) ->
  isMounted = useComponentIsMountedRef()
  [state, dispatch] = useReducer(reducer, initialState)

  protectedDispatch = (args...) ->
    return unless isMounted.current
    dispatch(args...)

  <CreateMacroDataContext.Provider value={[state, protectedDispatch]}>
    { children }
  </CreateMacroDataContext.Provider>

export useCreateMacroData = () ->
  useContext(CreateMacroDataContext)
